var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsEmail, IsEnum, IsNotEmpty, IsOptional, IsString, MaxLength, ValidateIf, } from 'class-validator';
import { CaregiverRelationship } from '../enums/caregiver.enum.js';
/** `null`, `undefined` and `''` all mean "not recorded" and skip the checks. */
const isGiven = (_, value) => value !== null && value !== undefined && value !== '';
/**
 * A caregiver the office records on a patient (#1839, ADR-0042): someone
 * from the patient's life, with how to reach them. The patient is the route
 * parameter, not a body field.
 */
export class CreateCaregiverEntryDto {
    name;
    relationship;
    /** `null` or empty: no phone recorded. */
    phone;
    /** `null` or empty: no email recorded. */
    email;
}
__decorate([
    IsString(),
    IsNotEmpty(),
    MaxLength(255),
    __metadata("design:type", String)
], CreateCaregiverEntryDto.prototype, "name", void 0);
__decorate([
    IsEnum(CaregiverRelationship),
    __metadata("design:type", String)
], CreateCaregiverEntryDto.prototype, "relationship", void 0);
__decorate([
    ValidateIf(isGiven),
    IsString(),
    MaxLength(50),
    __metadata("design:type", Object)
], CreateCaregiverEntryDto.prototype, "phone", void 0);
__decorate([
    ValidateIf(isGiven),
    IsEmail(),
    MaxLength(255),
    __metadata("design:type", Object)
], CreateCaregiverEntryDto.prototype, "email", void 0);
/** Corrects one or more fields of an entry; an omitted field stays as it is. */
export class UpdateCaregiverEntryDto {
    name;
    relationship;
    phone;
    email;
}
__decorate([
    IsOptional(),
    IsString(),
    IsNotEmpty(),
    MaxLength(255),
    __metadata("design:type", String)
], UpdateCaregiverEntryDto.prototype, "name", void 0);
__decorate([
    IsOptional(),
    IsEnum(CaregiverRelationship),
    __metadata("design:type", String)
], UpdateCaregiverEntryDto.prototype, "relationship", void 0);
__decorate([
    ValidateIf(isGiven),
    IsString(),
    MaxLength(50),
    __metadata("design:type", Object)
], UpdateCaregiverEntryDto.prototype, "phone", void 0);
__decorate([
    ValidateIf(isGiven),
    IsEmail(),
    MaxLength(255),
    __metadata("design:type", Object)
], UpdateCaregiverEntryDto.prototype, "email", void 0);
/** One caregiver entry as the patient file shows it. */
export class CaregiverEntryResponseDto {
    id;
    patientId;
    name;
    relationship;
    phone;
    /**
     * The address the office recorded. While access is `REGISTERED` it is the
     * caregiver's Login address, which only they can change (#1840).
     */
    email;
    accessStatus;
    /** The staff member who sent the invite that granted access, and when (#1840). */
    accessGrantedBy;
    /** ISO timestamp. */
    accessGrantedAt;
}
/**
 * Someone with access to the patient's data in the Active office, as the
 * patient's own read-only list in „Mein Konto“ shows them (#1840).
 */
export class CaregiverWithAccessDto {
    id;
    name;
    relationship;
}
/**
 * Refusal code when an entry's address is an Account that already has access
 * to the same patient through another entry: one link per (patient, Account).
 */
export const CAREGIVER_ACCESS_EXISTS = 'CAREGIVER_ACCESS_EXISTS';
/** Whether an API error is the `CAREGIVER_ACCESS_EXISTS` refusal. */
export function caregiverAccessExistsRefusal(data) {
    if (data &&
        typeof data === 'object' &&
        data.code === CAREGIVER_ACCESS_EXISTS) {
        return data;
    }
    return null;
}
//# sourceMappingURL=caregiver-entry.dto.js.map